import { createContext } from "react";

export const AreYouSureContext = createContext();
